import {IApp} from "@/interfaces/app.interface";
import moment from "moment";

export namespace IAppTable {
  export interface ISortTableDataPayload {
    tableData: any[];
    sortingTable: ISortingData;
    limitTotal?: number;
  }

  export interface ISortingData {
    prop: string;
    propType: IApp.SortingPropType;
    direction: IApp.SortDirection;
  }

  export interface ITableProp {
    label: string;
    prop: string;
    propType?: IApp.SortingPropType;
    colspan?: number; // need for print tables.
    isMoney?: boolean;
    dateFormat?: string;
    noPrint?: boolean;
    mobileHide?: boolean;
    actionClick?: any;
    actions?: ITableActionOptions[];
    usePrintedValue?: boolean;
    addClassFunction?: Function;
    rowClass?: string;
    noSorting?: boolean;
    noTitle?: boolean;

    customComponentName?: string;
    customComponentProps?: any;
  }

  export interface ITableActionOptions {
    tooltip?: string;
    icon?: string;
    text?: string;
    actionClick?: Function;
    disabled?: boolean;
  }

  export enum StorageKeys {
    SimpleTableSorting = 'simpleTableSorting',
  }

  export function SortTableData({ tableData, sortingTable, limitTotal = 1000 }: ISortTableDataPayload) {
    if (!sortingTable.prop || sortingTable.direction === IApp.SortDirection.Default) {
      return {
        array: tableData,
        originalCount: tableData.length,
      };
    }

    const withValue = [];
    const withoutValue = [];
    tableData.forEach(tableRow => {
      if (tableRow[sortingTable.prop]
        || [IApp.SortingPropType.Number, IApp.SortingPropType.Boolean].includes(sortingTable.propType))
        withValue.push(tableRow);
      else
        withoutValue.push(tableRow);
    });

    const sortProp = sortingTable.prop;
    let sortedItems = [];
    const directionValue = sortingTable.direction === IApp.SortDirection.Up ? 1 : -1;
    switch (sortingTable.propType) {
      case IApp.SortingPropType.Date:
        sortedItems = withValue.sort((a, b) =>
          Number(moment(a[sortProp]).format('x')) > Number(moment(b[sortProp]).format('x'))
            ? directionValue
            : -1 * directionValue
        );
        break;

      case IApp.SortingPropType.String:
        sortedItems = withValue.sort((a, b) =>
          a[sortProp].toLowerCase() > b[sortProp].toLowerCase() ? directionValue : -1 * directionValue);
        break;

      case IApp.SortingPropType.Number:
        sortedItems = withValue.sort((a, b) => {
          let aValue = !!a[sortProp] ? Number(a[sortProp]) : 0;
          let bValue = !!b[sortProp] ? Number(b[sortProp]) : 0;
          return aValue > bValue ? directionValue : -1 * directionValue
        });
        break;

      default:
        sortedItems = withValue.sort((a, b) =>
          a[sortProp] > b[sortProp] ? directionValue : -1 * directionValue);
        break;
    }

    let result = [...sortedItems, ...withoutValue];
    const originalCount = result.length;
    result = result.slice(0, limitTotal);

    return {
      array: result,
      originalCount,
    };
  }

  export function SetSorting(sortingTable: ISortingData, cell: ITableProp, tableName: string): ISortingData {
    let compareDirection = sortingTable.direction;
    if (sortingTable.prop !== cell.prop) {
      compareDirection = IApp.SortDirection.Default;
    }

    let direction = IApp.SortDirection.Default;
    let prop = cell.prop;
    switch (compareDirection) {
      case IApp.SortDirection.Default:
      default:
        direction = IApp.SortDirection.Up;
        break;

      case IApp.SortDirection.Up:
        direction = IApp.SortDirection.Down;
        break;

      case IApp.SortDirection.Down:
        direction = IApp.SortDirection.Default;
        prop = null;
        break;
    }

    let resultData = {
      prop,
      propType: cell.propType ? cell.propType : IApp.SortingPropType.String,
      direction,
    };

    let dataForStorage = { [tableName]: resultData };
    let storageData = localStorage.getItem(StorageKeys.SimpleTableSorting);
    if (storageData && !!JSON.parse(storageData)) {
      dataForStorage = {
        ...JSON.parse(storageData),
        ...dataForStorage,
      };
    }
    localStorage.setItem(StorageKeys.SimpleTableSorting, JSON.stringify(dataForStorage));

    return resultData;
  }

  export function PresetStorageSorting(tableName: string): ISortingData {
    let storageData = localStorage.getItem(StorageKeys.SimpleTableSorting);
    let resultSorting = null;
    if (!!storageData) {
      let parsedData = JSON.parse(storageData);
      resultSorting = parsedData[tableName];
    }
    return resultSorting;
  }

  export function ScrollTableToTop(selector: string = '.app-page__content') {
    setTimeout(() => {
      let tableContainer = document.querySelector(selector);
      if (tableContainer) {
        tableContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 0);
  }
}

